import { VueHammer } from 'vue2-hammer';

export default {
  install(Vue) {
    Vue.use(VueHammer);
  },
};
